import { FIRMFLOWURL } from "../url";
import axios from "axios";
import Cookies from "js-cookie";
import { administrativeError } from "../administrativeError";

export async function getReassignPreview(teamId) {
    try {
        const response = await axios.get(
            `${FIRMFLOWURL}api/Team/${encodeURIComponent(teamId)}/reassign/preview`,
            { headers: { Authorization: Cookies.get("Bearer") }, suppressForbiddenToast: true, timeout: 30000 },
        );
        return { ...response, success: true };
    } catch (error) {
        return administrativeError(error, "Could not load the reassignment preview. Please try again later.");
    }
}
